import axiosClient from '../axiosClient';
import { OrderRerunsEndpoints } from '../endpoints/orderReruns';
import {
  IGetOrderRerunsResponse,
  IOrderRerunSearchParams,
} from '../../types/api/response/orderrerunsresponse';

export const OrderRerunsService = {
  async searchRerunHistory(params: IOrderRerunSearchParams): Promise<IGetOrderRerunsResponse> {
    const res = await axiosClient.get<IGetOrderRerunsResponse>(
      OrderRerunsEndpoints.SEARCH_ORDER_RERUNS,
      { params },
    );
    return res.data;
  },
};
